// extracted by mini-css-extract-plugin
export var dateLabel = "_2v-0";
export var dateLabelError = "_2v-1";
export var fullWidth = "_2v-2";
export var smaller = "_2v-3";